import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Responsive, Tags, useDeviceType } from '@cian/ui-kit';

import { DEFAULT_MOBWEB_TAGS_COUNT } from './constants';
import { promosApplyFiltersRequestAction } from '../../actions/filters';
import { extractJsonQueryAction } from '../../actions/jsonQuery';
import { SearchSuggestTagsLayout } from '../../components/SearchSuggestTagsLayout';
import { ToggleTagsButton } from '../../components/ToggleTagsButton';
import { selectSearchTags } from '../../selectors/tags';
import { TThunkDispatch } from '../../types/redux/thunk';

export const SearchSuggestTagsContainer: React.FC = () => {
  const tags = useSelector(selectSearchTags);
  const dispatch: TThunkDispatch = useDispatch();
  const deviceType = useDeviceType();

  const [allMobwebTagsShown, setAllMobwebTagsShown] = React.useState(false);

  const tagSize = React.useMemo(() => (deviceType === 'phone' ? 'M' : 'XS'), [deviceType]);
  const displayTags = React.useMemo(() => {
    const displayTags = tags.map((tag, idx) => ({ label: tag.name, value: String(idx) }));

    if (deviceType !== 'desktop' && !allMobwebTagsShown) {
      return displayTags.slice(0, DEFAULT_MOBWEB_TAGS_COUNT);
    }

    return displayTags;
  }, [allMobwebTagsShown, deviceType, tags]);

  const handleToggleTagsButtonClick = React.useCallback(() => {
    setAllMobwebTagsShown(shown => !shown);
  }, []);

  const handleTagClear = React.useCallback(
    ({ value }: { value: string }) => {
      const index = +value;
      const tag = tags[index];

      dispatch(extractJsonQueryAction(tag.jsonQuery));
      dispatch(promosApplyFiltersRequestAction());
    },
    [dispatch, tags],
  );

  if (displayTags.length === 0) {
    return null;
  }

  return (
    <SearchSuggestTagsLayout
      toggleButton={
        tags.length > DEFAULT_MOBWEB_TAGS_COUNT && (
          <Responsive tablet phone>
            <ToggleTagsButton
              allTagsLength={tags.length}
              displayTagsLength={displayTags.length}
              onClick={handleToggleTagsButtonClick}
            />
          </Responsive>
        )
      }
    >
      <Tags size={tagSize} options={displayTags} onClose={handleTagClear} />
    </SearchSuggestTagsLayout>
  );
};
